<template>
  <div class="accelerator-requests">
    <b-card header-bg-variant="default" class="border-0">
      <b-row>
        <b-col cols="6">
          <h4 class="text-center c-dark">عنوان گزارش</h4>
          <b-form-group disabled>
            <b-form-input
              v-model="acceleratorReport.subject"
              class="text-center"
              style="font-size: 1.2em"
            >
            </b-form-input>
          </b-form-group> </b-col
        ><b-col cols="6">
          <h4 class="text-center c-dark">درصد پیشرفت</h4>
          <b-form-group disabled>
            <b-form-input
              class="text-center"
              v-model="acceleratorReport.percent"
              style="font-size: 1.2em"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <h4 class="text-center c-dark mt-4">توضیحات</h4>
      <b-form-group disabled>
        <b-form-textarea
          class="text-center"
          v-model="acceleratorReport.description"
          style="font-size: 1.2em"
        ></b-form-textarea>
      </b-form-group>
      <div class="custom-table">
        <b-table
          responsive
          small
          show-empty
          stacked="sm"
          tbody-tr-class="trClass"
          thead-class="thClass"
          :items="reportFiles"
          :fields="acceleratorFileFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="mt-4"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
          <template v-slot:cell(url)="data">
            <div style="text-align: center; vertical-align: middle">
              <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
              <a
                v-if="data.value"
                class="btn bc-purple white--text"
                :href="data.value"
                target="_blank"
              >
                <v-icon class="white--text" small>mdi-download-outline</v-icon>
                دریافت فایل</a
              >
            </div>
          </template>
        </b-table>
      </div>
      <hr />
      <b-card header-bg-variant="default" class="border-0 mt-3">
        <template v-slot:header>
          <h4 class="mb-0 text-center">نظر نهایی</h4>
        </template>
        <br />

        <div class="d-flex mb-3 justify-content-center">
          <b-form-radio-group size="lg" v-model="review.reportJudge">
            <div class="d-flex mb-3">
              <div class="d-flex" dir="rtl">
                <b-form-radio value="approve"></b-form-radio>
                <label class="ml-2 mt-1"><h5>تایید</h5></label>
              </div>
              <div class="d-flex" dir="rtl">
                <b-form-radio value="reject"></b-form-radio>
                <label class="ml-2 mt-1"><h5>رد</h5></label>
              </div>
            </div>
          </b-form-radio-group>
        </div>
        <div
          v-if="
            review.reportJudge == 'approve' || review.reportJudge == 'reject'
          "
        >
          <b-row
            style="
              border: red solid 2px;
              padding: 15px;
              border-radius: 10px;
              margin: 8px;
            "
          >
            <i
              class="fa fa-exclamation-triangle fa-2x text-warning ml-2"
              aria-hidden="true"
            ></i>
            <p class="mt-2 ml-2 text-danger">
              تذکر: شتاب‌دهنده گرامی، لطفا پس از بررسی دقیق گزارش، میزان پیشرفت
              را مشخص بفرمایید، دقت نمایید که میزان پیشرفت اعلام شده توسط شما
              ملاک عمل و نتیجه گیری نهایی خواهد بود
            </p>
          </b-row>
          <b-form-group
            label="درصد کل پیشرفت پروژه از ابتدا تا کنون از 100 :"
            class="mt-10"
          >
            <b-form-input
              type="number"
              :no-wheel="true"
              min="0"
              max="100"
              class="myselect2"
              @change="over100()"
              v-model="review.judgePercent"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group class="mt-3">
            <label>{{
              review.reportJudge == "reject" ? "دلایل رد:" : "توضیحات:"
            }}</label>
            <b-form-textarea
              class="myselect2"
              v-model="review.judgeDescription"
            >
            </b-form-textarea>
          </b-form-group>
        </div>
        <div class="d-flex mb-3 mt-3" v-if="review.reportJudge">
          <v-btn
            elevation="0"
            class="bc-primary"
            @click="addJudgeReport()"
            :disabled="computedDisable || judgeBusy"
          >
            <v-icon class="white--text pe-2" small>mdi-check-outline</v-icon>
            <span class="white--text">ثبت</span>
          </v-btn>
        </div>
      </b-card>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ["acceleratorReport", "reportFiles", "type"],
  data() {
    return {
      acceleratorFileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      review: {
        reportJudge: "approve",
        judgePercent: null,
        judgeDescription: "",
      },
      tabIndex: 3,
      judgeBusy: false,
      max: 100,
      reportItems: [],
      reports: [],
      acc: 0,
      isLoaded: true,
      reportFile: [],
      reportFinanceFile: [],
      myPcFile: [],
      reviewers: [],
    };
  },

  methods: {
    addJudgeReport() {
      this.judgeBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/report/" + this.type + "/done",
          {
            reportId: this.$route.params.id,
            reportAcceleratorPerc: this.review.judgePercent,
            reportAcceleratorDecision: this.review.reportJudge,
            acceleratorDescription: this.review.judgeDescription,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
          }

          this.$router.push("/accelerator/doneProjectsControl");
          this.judgeBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.judgeBusy = false;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        });
    },
    over100() {
      if (this.review.judgePercent > 100 || this.review.judgePercent < 0) {
        this.review.judgePercent = "";
      }
    },
  },
  computed: {
    computedDisable() {
      if (this.review.judgeDescription && this.review.judgePercent) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

.contract-section {
  .custom-control-inline {
    margin-right: 0 !important;
  }
}

.diabled-textarea {
  color: grey;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  min-height: 45px;
  position: relative;
  padding-top: 10px;
  background-color: #e4e7ea;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}

strong {
  color: #fff !important;
}
#forceFinishedModal___BV_modal_header_ {
  button {
    margin: -1rem !important;
  }
}
.form-group {
  margin-bottom: 0 !important;
}
</style>
